
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA au Mans dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads au Mans certifiée Google Partner, accompagne les entreprises mancelles pour développer leur visibilité en ligne et attirer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads au Mans dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads au Mans certifiée Google Partner, accompagne les entreprises mancelles pour développer leur visibilité en ligne et attirer plus de prospects.",
        },
      ],
    };
  },
};
